<script setup lang="ts">
import { Icon } from '@/shared/ui';

const { size } = defineProps<{ size: string | number }>();
</script>

<template>
  <Icon
    name="material-symbols:edit"
    :width="size"
    :height="size"
  />
</template>
